import React, { useEffect, useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import T from '@prisjakt/ui-translate';
import { Card, CardMedia } from '@prisjakt/ui/card';
import Clickable from '@prisjakt/ui-clickable';
import ProsAndCons from '../pros-and-cons';
import ExpertUserCard from '../../../components/expert-user-card';
import Badge from '../../../components/badge';
import ExpertRating from '../../../components/rating';

import * as S from './styles';
import { Subtitle, Title } from '../../../styles';

import {
  trackExpertTestSummaryViewed,
  trackExpertTestSummaryClicked,
} from '../../../tracking';

import { AdvizedTest } from '../../../../../types';
import { ContentTypes } from '../../../types';

type Props = {
  productId: number;
  review: AdvizedTest;
};

const TestSummary = ({ review }: Props) => {
  const { linkTo, t } = useContext(AppContext);

  const {
    expert,
    grade,
    title,
    plus,
    minus,
    image,
    imageWithSize,
    suitedFor,
    url,
  } = review;

  useEffect(() => {
    trackExpertTestSummaryViewed({ title });
  }, []);

  return (
    <Card>
      <CardMedia>
        {image && (
          <img
            alt={imageWithSize?.alt || ''}
            src={imageWithSize?.src || image}
          />
        )}
      </CardMedia>

      <S.Content>
        <Title>
          <Badge type={ContentTypes.TEST} />: {title}
        </Title>

        <S.Summary>
          <ProsAndCons type="pros" strings={plus} />
          <ProsAndCons type="cons" strings={minus} />
        </S.Summary>

        <div>
          <Subtitle>{t('expert', 'title.grade')}:</Subtitle>
          <ExpertRating as="stars" grade={grade} />
        </div>

        {suitedFor?.text && (
          <S.TextBlock>
            {suitedFor.headline && <b>{suitedFor.headline}</b>}
            <span dangerouslySetInnerHTML={{ __html: suitedFor.text }} />
          </S.TextBlock>
        )}

        <ExpertUserCard
          experts={[expert]}
          subtitle={t('expert', 'expert.role')}
        />

        <S.ReadMore
          component={
            <Clickable to={linkTo('expertTest', { semantic_id: url })} />
          }
          onClick={() => trackExpertTestSummaryClicked({ title })}
          variant="outlined"
          color="primary"
        >
          <T domain="expert">test.read-more</T>
        </S.ReadMore>
      </S.Content>
    </Card>
  );
};

export default TestSummary;
